import { BrowserRouter as Router, Routes, Route, useLocation, Link } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Classes from "./pages/Classes";
import ClassPage from "./pages/ClassPage";
import SeatingPlan from "./pages/SeatingPlan";
import StudentReminders from "./pages/StudentReminders";
import ProtectedRoute from "./ProtectedRoute";
import Navbar from "./components/Navbar";
import { AuthProvider } from "./AuthContext";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Analytics from "./pages/Analytics";
import Feedback from "./pages/Feedback";
import AdminFeedback from "./pages/AdminFeedback";
import AdminUsers from "./pages/AdminUsers";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminSarLog from "./pages/AdminSarLog";
import PrivacyNotice from "./pages/PrivacyNotice";
import RetentionPolicy from "./pages/RetentionPolicy";
import ComplianceBaseline from "./pages/ComplianceBaseline";
import Ropa from "./pages/Ropa";
import DpiaOutline from "./pages/DpiaOutline";
import { useEffect } from "react";
import { logUsageEvent } from "./utils/usageAnalytics";

function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    logUsageEvent({
      type: "page_view",
      name: location.pathname,
      meta: { search: location.search },
    });
  }, [location.pathname, location.search]);

  return null;
}

function AppLayout() {
  const location = useLocation();
  const hideNavbar = location.pathname.endsWith("/reminders");

  return (
    <>
      <PageViewTracker />
      {!hideNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/privacy" element={<PrivacyNotice />} />
        <Route path="/retention" element={<RetentionPolicy />} />
        <Route path="/compliance" element={<ComplianceBaseline />} />
        <Route path="/ropa" element={<Ropa />} />
        <Route path="/dpia" element={<DpiaOutline />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/classes"
          element={
            <ProtectedRoute>
              <Classes />
            </ProtectedRoute>
          }
        />
        <Route
          path="/analytics"
          element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/class/:id/analytics" 
          element={
          <ProtectedRoute>
            <Analytics />
          </ProtectedRoute>
          } 
        />
        <Route
          path="/classes/:id"
          element={
            <ProtectedRoute>
              <ClassPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/classes/:id/seating"
          element={
            <ProtectedRoute>
              <SeatingPlan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/classes/:id/reminders"
          element={
            <ProtectedRoute>
              <StudentReminders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/feedback"
          element={
            <ProtectedRoute>
              <Feedback />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/feedback"
          element={
            <ProtectedRoute>
              <AdminFeedback />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute>
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute>
              <AdminAnalytics />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sar"
          element={
            <ProtectedRoute>
              <AdminSarLog />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <DndProvider backend={HTML5Backend}>
    <AuthProvider>
    <Router>
      <AppLayout />
    </Router>
 </AuthProvider>
 </DndProvider>
 );
}

function Footer() {
  return (
    <footer
      style={{
        borderTop: "1px solid #e2e2e2",
        padding: "1rem 1.5rem",
        display: "flex",
        justifyContent: "center",
        gap: "1rem",
        flexWrap: "wrap",
        color: "#555",
      }}
    >
      <Link to="/privacy">Privacy notice</Link>
      <Link to="/retention">Retention policy</Link>
      <Link to="/compliance">Compliance baseline</Link>
      <Link to="/ropa">ROPA</Link>
      <Link to="/dpia">DPIA outline</Link>
    </footer>
  );
}

export default App;